import Image from "next/image";
import Link from "next/link";
import type { SiteTemplateKey } from "@/lib/siteTemplates";
import { getTemplateStyles } from "@/lib/siteTemplateStyles";

export function HeroBlock({
  content,
  template = "classic",
  headingLevel = 1,
}: {
  content: Record<string, unknown>;
  template?: SiteTemplateKey;
  headingLevel?: 1 | 2;
}) {
  const heading = String(content.heading ?? "");
  const subheading = String(content.subheading ?? "");
  const buttonText = content.buttonText ? String(content.buttonText) : null;
  const buttonUrl = content.buttonUrl ? String(content.buttonUrl) : null;
  const backgroundImage = content.backgroundImage
    ? String(content.backgroundImage)
    : null;
  const overlay = Boolean(content.overlay);
  const objectPosition = content.objectPosition
    ? String(content.objectPosition)
    : "center center";

  const styles = getTemplateStyles(template);
  const HeadingTag = headingLevel === 1 ? "h1" : "h2";

  return (
    <section data-template={template} className={styles.hero.section}>
      {backgroundImage && (
        <Image
          src={backgroundImage}
          alt=""
          fill
          className="object-cover"
          style={{ objectPosition }}
          priority
          sizes="100vw"
        />
      )}
      {overlay && styles.hero.overlay && (
        <div className={styles.hero.overlay} />
      )}
      <div className={styles.hero.container}>
        <div className="flex flex-col gap-[calc(var(--space-unit)*1)]">
          <HeadingTag
            className={`font-bold ${styles.hero.headingColor}`}
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: styles.hero.headingSize,
              lineHeight: "var(--line-display)",
            }}
          >
            {heading}
          </HeadingTag>
          {subheading && (
            <p className={`max-w-3xl text-lg ${styles.hero.subheadingColor}`}>
              {subheading}
            </p>
          )}
          {buttonText && buttonUrl && (
            <Link href={buttonUrl} className={styles.hero.button}>
              {buttonText}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
